export default {"src":"/static/spa/fresh-spa/_next/static/media/icon-calendar.0abee47e.svg","height":126,"width":131,"blurWidth":0,"blurHeight":0};